import React, { useState, useEffect } from "react";
import RbuImg1 from "../../assets/RbuImg1.png";
import Layout from "../Layout/Layout";
import verticalDots from "../../assets/verticalDots.svg";
import RbuImg3 from "../../assets/RbuImg3.png";
import RbuImg5 from "../../assets/RbuImg5.png";
import axios from "axios";
import { motion } from "framer-motion";
import { formatDate } from "../common/dateFormatter";

const BlogInside = () => {
  const [blog, setBlog] = useState({});
  useEffect(() => {
    const getQueryParamId = () => {
      const queryParams = new URLSearchParams(window.location.search);
      return queryParams.get("id");
    };
    const getAllBlogs = () => {
      const id = getQueryParamId();
      console.log(
        "${process.env.REACT_PUBLIC_BASE_URL}",
        process.env.REACT_APP_BASE_URL,
      );
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/blogs/${id}`)
        .then((response) => {
          console.log("Bloggggggggggg", response?.data?.data);
          setBlog(response?.data?.data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    };
    getAllBlogs();
  }, []);
  console.log("blogsblogsblogsblogs", blog);

  const bubbleSVG1 = (
    <svg
      width="165"
      height="165"
      viewBox="0 0 165 165"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="165"
        y="165"
        width="165"
        height="165"
        rx="82.5"
        transform="rotate(180 165 165)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const bubbleSVG2 = (
    <svg
      width="58"
      height="83"
      viewBox="0 0 58 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="83"
        height="83"
        rx="41.5"
        transform="matrix(1 0 0 -1 0 83)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const bubbleSVG3 = (
    <svg
      width="83"
      height="83"
      viewBox="0 0 83 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="83"
        y="83"
        width="83"
        height="83"
        rx="41.5"
        transform="rotate(180 83 83)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const bubbleSVG4 = (
    <svg
      width="348"
      height="339"
      viewBox="0 0 348 339"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="348" height="339" rx="169.5" fill="#E9EFFF" />
    </svg>
  );

  const bubbleSVG5 = (
    <svg
      width="113"
      height="113"
      viewBox="0 0 113 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="113"
        y="113"
        width="113"
        height="113"
        rx="56.5"
        transform="rotate(180 113 113)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const bubbleSVG6 = (
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="47"
        y="47"
        width="47"
        height="47"
        rx="23.5"
        transform="rotate(180 47 47)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const bubbleSVG7 = (
    <svg
      width="97"
      height="97"
      viewBox="0 0 97 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="97"
        y="97"
        width="97"
        height="97"
        rx="48.5"
        transform="rotate(180 97 97)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const cardsData = [
    {
      img: RbuImg1,
      title: "A Comprehensive Guide to Building Your First Aid Kit For Home",
      date: "2023-09-23",
      comments: "No Comments",
      content:
        "Every second matters during times of emergency. It is therefore essential to have a well-stocked first aid kit at home. A first aid kit provides",
    },
    {
      img: RbuImg3,
      title: "A Comprehensive Guide to Building Your First Aid Kit For Home",
      date: "2023-09-23",
      comments: "No Comments",
      content:
        "Every second matters during times of emergency. It is therefore essential to have a well-stocked first aid kit at home. A first aid kit provides",
    },
    {
      img: RbuImg5,
      title: "A Comprehensive Guide to Building Your First Aid Kit For Home",
      date: "2023-09-23",
      comments: "No Comments",
      content:
        "Every second matters during times of emergency. It is therefore essential to have a well-stocked first aid kit at home. A first aid kit provides",
    },
  ];

  const Card = ({ img, title, date, comments, content }) => (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:border-blue-200"
    >
      <div className="relative overflow-hidden">
        <img
          className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500"
          src={img}
          alt="blog post"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-4 right-4 bg-[#B02526] text-white px-3 py-1 rounded-full text-xs font-semibold">
          Featured
        </div>
      </div>

      <div className="p-6">
        <h3 className="font-bold text-lg text-[#183864] mb-3 line-clamp-2 group-hover:text-[#B02526] transition-colors duration-300">
          {title}
        </h3>

        <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
          <div className="flex items-center gap-1">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clipRule="evenodd"
              />
            </svg>
            <span>{formatDate(date)}</span>
          </div>
          <div className="flex items-center gap-1">
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
            <span>{comments}</span>
          </div>
        </div>

        <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
          {content}
        </p>

        <button className="inline-flex items-center text-[#B02526] font-semibold text-sm hover:text-[#8B1E1F] transition-colors duration-300 group">
          <span className="mr-2">Read More</span>
          <svg
            className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </button>
      </div>
    </motion.div>
  );

  const CardList = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
      {cardsData?.map((card, index) => (
        <Card key={index} {...card} />
      ))}
    </div>
  );

  return (
    <Layout>
      {/* Main Content Wrapper */}
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
        {/* Hero Image Section */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="relative pt-8 pb-12 overflow-hidden"
        >
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative">
              <img
                className="w-full h-[300px] md:h-[400px] lg:h-[500px] object-cover rounded-3xl shadow-2xl border border-gray-200"
                src={`${process.env.REACT_APP_BASE_URL}/${blog?.image}`}
                alt="Blog featured image"
              />

              {/* Overlay with gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-3xl"></div>

              {/* Floating badge */}
              <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
                <div className="flex items-center gap-2 text-sm font-medium text-[#183864]">
                  <div className="w-2 h-2 bg-[#B02526] rounded-full animate-pulse"></div>
                  <span>Featured Article</span>
                </div>
              </div>
            </div>
          </div>

          {/* Background decorative elements */}
          <div className="absolute left-0 top-[15%] -z-10 opacity-30">
            <img
              className="w-16 h-16 md:w-20 md:h-20"
              src={verticalDots}
              alt=""
            />
          </div>
          <div className="absolute right-0 top-[10%] -z-10 opacity-20">
            <img
              className="w-16 h-16 md:w-20 md:h-20"
              src={verticalDots}
              alt=""
            />
          </div>
        </motion.section>

        {/* Article Header Section */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative pb-8"
        >
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              {/* Category badge */}
              <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 text-sm font-medium rounded-full mb-6">
                <svg
                  className="w-4 h-4 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Safety Guide
              </div>

              {/* Title */}
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-[#183864] via-[#2563eb] to-[#B02526] bg-clip-text text-transparent mb-6 leading-tight">
                {blog?.title}
              </h1>

              {/* Meta information */}
              <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-medium">
                    {formatDate(blog?.date || blog?.createdAt)}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span>8 min read</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                  <span>1.2k views</span>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/* Article Content */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="relative pb-12"
        >
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-12">
              {/* Introduction */}
              <div className="prose prose-lg max-w-none mb-12">
                <p className="text-xl text-gray-700 leading-relaxed font-light italic border-l-4 border-[#B02526] pl-6 bg-gray-50 p-6 rounded-r-xl">
                  {blog?.desc}
                </p>
              </div>

              {/* Sections */}
              {blog?.sections?.length > 0 &&
                blog?.sections?.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    className="mb-12"
                  >
                    <div className="flex items-center gap-4 mb-6">
                      <div className="w-8 h-8 bg-gradient-to-r from-[#183864] to-[#B02526] rounded-full flex items-center justify-center text-white font-bold text-sm">
                        {index + 1}
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-[#183864] flex-1">
                        {item.title}
                      </h2>
                    </div>

                    <p className="text-gray-700 text-lg leading-relaxed mb-8">
                      {item.desc}
                    </p>

                    {item?.subSections?.length > 0 && (
                      <div className="space-y-6">
                        {item?.subSections?.map((sub, subIndex) => (
                          <div
                            key={subIndex}
                            className="flex gap-4 p-6 bg-gradient-to-r from-blue-50 to-transparent rounded-xl border-l-4 border-blue-400"
                          >
                            <div className="flex-shrink-0 w-6 h-6 bg-[#B02526] text-white rounded-full flex items-center justify-center text-xs font-bold">
                              {subIndex + 1}
                            </div>
                            <div className="flex-1">
                              <span className="font-bold text-[#183864] text-lg">
                                {sub.key}:
                              </span>
                              <span className="text-gray-700 ml-2">
                                {sub.value}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </motion.div>
                ))}
            </div>
          </div>

          {/* Background decorative elements */}
          <div className="absolute left-2 top-1/2 -z-10 opacity-10">
            <img
              className="w-16 h-16 md:w-20 md:h-20"
              src={verticalDots}
              alt=""
            />
          </div>
          <div className="absolute right-0 bottom-1/4 -z-10 opacity-10">
            <img
              className="w-16 h-16 md:w-20 md:h-20"
              src={verticalDots}
              alt=""
            />
          </div>
        </motion.section>

        {/* Conclusion Section */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative pb-16"
        >
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-gradient-to-r from-[#183864] to-[#2563eb] rounded-2xl p-8 md:p-12 text-white relative overflow-hidden">
              <div className="relative z-10">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold">
                    Key Takeaways
                  </h2>
                </div>

                <p className="text-xl leading-relaxed text-blue-100">
                  {blog?.conclusion}
                </p>
              </div>

              {/* Background pattern */}
              <div className="absolute top-0 right-0 opacity-10">
                {bubbleSVG4}
              </div>
            </div>
          </div>
        </motion.section>

        {/* Recommended Articles Section */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative pb-20 pt-8"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Section Header */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center px-4 py-2 bg-orange-100 text-orange-800 text-sm font-medium rounded-full mb-6">
                <svg
                  className="w-4 h-4 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                </svg>
                More Safety Tips
              </div>

              <h2 className="text-4xl md:text-5xl font-bold mb-4">
                <span className="text-[#183864]">Recommended For You</span>
              </h2>

              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Discover more essential safety guides and expert insights to
                keep you prepared
              </p>
            </div>

            {/* Cards Grid */}
            <CardList />
          </div>

          {/* Background decorative elements */}
          <div className="absolute left-[15%] top-[10%] -z-10 opacity-5">
            {bubbleSVG7}
          </div>
          <div className="absolute right-0 top-1/2 -z-10 opacity-5">
            {bubbleSVG2}
          </div>
        </motion.section>

        {/* Newsletter Section */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative bg-gradient-to-r from-[#183864] to-[#2563eb] text-white py-16"
        >
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            <div className="mb-8">
              <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
                <svg
                  className="w-4 h-4 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                Stay Connected
              </div>

              <h3 className="text-3xl md:text-4xl font-bold mb-4">
                Never Miss a Safety Update
              </h3>
              <p className="text-xl text-blue-100 max-w-2xl mx-auto">
                Get the latest safety tips, emergency preparedness guides, and
                industry insights delivered directly to your inbox.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
              <input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 px-6 py-4 rounded-full text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 text-lg"
              />
              <button className="px-8 py-4 bg-[#B02526] text-white font-semibold rounded-full hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                Subscribe Now
              </button>
            </div>
          </div>

          {/* Decorative elements */}
          <div className="absolute top-8 left-8 opacity-20">
            <div className="w-6 h-6 bg-white rounded-full animate-pulse"></div>
          </div>
          <div className="absolute bottom-8 right-8 opacity-15">
            <div className="w-8 h-8 border-2 border-white rounded-full animate-bounce"></div>
          </div>
          <div className="absolute top-1/2 left-1/4 opacity-10">
            <div className="w-4 h-4 bg-white rounded-full"></div>
          </div>
        </motion.section>
      </div>
    </Layout>
  );
};

export default BlogInside;
